import { useState, useEffect } from "react";
import { Button, Skeleton } from "../../../../../components";
import { fetchTemplateById } from "../../../../../redux/slices/compaigns/compaignsApi";

const ViewEmailTemplate = ({ onCancel, templateId, setEmailBody }) => {
  const [body, setBody] = useState("");
  const [loading, setLoading] = useState(false);
  const fetchBody = async () => {
    try {
      setLoading(true);
      let filter = {
        uiid : {
          type : "IN",
          value : [templateId]
        }
      }
      const response = await fetchTemplateById({ coll: "Template", fil: filter, ret: "body" });  
      setBody(response?.data?.body || "");
    } catch (error) {
      console.error("Error fetching template body:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDuplicate = () => {
    setEmailBody(body);
    onCancel(); 
  }
  useEffect(() => {
     fetchBody();
  },[])
  return (
    <div className="h-120">
      <div className="border-1 border-gray-200 rounded-lg m-2 p-4 flex flex-col text-sm">
             {loading ? (
          <Skeleton variant="paragraph" lines={4} />
        ) : body ? (
          <div
            className="prose max-w-none w-full [overflow-wrap:anywhere]"
            dangerouslySetInnerHTML={{ __html: body }}
          />
        ) : (
          <p className="text-gray-500">No body available</p>
        )}
      </div>

      <div className="flex justify-center items-center gap-4 my-10">
        <Button
          title={"Cancel"}
          variant="outlined"
          color="black"
          onClick={onCancel}
        />
        <Button title={"Duplicate"} onClick={handleDuplicate} />
      </div>
    </div>
  );
};

export default ViewEmailTemplate;
